import { render, staticRenderFns } from "./MailTemplateEdit.vue?vue&type=template&id=2e0346ed"
import script from "./MailTemplateEdit.vue?vue&type=script&lang=js"
export * from "./MailTemplateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports